export function hideFromScreenReader(text: string, tagNames: string[]): string {
    // Future Task On develop if!text was deleted
    // if (!text) {
    // return ''
    //
    tagNames.forEach((tagName) => {
        const regex = new RegExp(`<${tagName}`, "g");
        text = text.replace(regex, `<${tagName} aria-hidden="true"`);
    });
    return text;
}
